import _ from 'lodash';
import { Identity } from '../domains/identity.domain';

export const isAuthorised = (response: Identity): boolean => {
	return _.some(response.roles, item =>
		['wmMkAdvisor', 'wmMkRoleAdvisor'].includes(item.roleName)
	);
};
